//@flow
import { connect } from 'react-redux';
import type { DispatchProps, StateProps } from './RoamingPackage';
import RoamingPackage from './RoamingPackage';
import {
  selectedRoamingPackageCountryIdSelector,
  selectedRoamingPackageZoneSelector,
} from '../../../../modules/International/Roaming/reducer';
import {
  canBuySelectedRoamingPackageSelector,
  selectedRoamingPackagePriceSelector,
  selectedRoamingPackageSelector,
} from '../../../../modules/TopUps/Bundle/selectors';
import config from '../../../../config';
import { getRoamingGroupCountries } from '../../../../lib/country-utils.js';
import type { StateType } from '../../../../modules/reducers';
import { sortOptions } from '../../../../lib/sort-options';
import { buyRoamingPackage } from '../../../../modules/International/Roaming/actions';
import bundleToOptionsAdapter from '../../../../lib/BundleToOptionsAdapter'; //TODO in SDK
import { fetchRoamingBundles } from '../../../../modules/Dashboard';
import { isExemptedFromTaxSelector } from '../../../../modules/Customer/selectors';
import { isLoadingSelector } from '../../../../modules/LoadingStatus';

const mapStateToProps = (state: StateType): StateProps => ({
  roamingGroupCountries: getRoamingGroupCountries(config.iddCountries, selectedRoamingPackageZoneSelector(state)),
  roamingCountryId: selectedRoamingPackageCountryIdSelector(state),
  roamingCountryZone: selectedRoamingPackageZoneSelector(state, true),
  price: selectedRoamingPackagePriceSelector(state),
  options: sortOptions(bundleToOptionsAdapter(selectedRoamingPackageSelector(state))),
  canBuy: canBuySelectedRoamingPackageSelector(state),
  isExemptedFromTax: isExemptedFromTaxSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
});

const mapDispatchToProps: DispatchProps = {
  buy: buyRoamingPackage,
  fetchRoamingBundles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoamingPackage);
